import { useState } from "react";
import { toast } from "sonner";
import { subscribe } from "@/lib/api";

export default function EmailSignup({
  source = "homepage",
  variant = "card",
  testIdPrefix = "email-signup",
}) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim()) {
      toast.error("Please fill in your name and email.");
      return;
    }
    setLoading(true);
    try {
      await subscribe({ name: name.trim(), email: email.trim(), source });
      toast.success("Welcome to the kitchen! Check your inbox soon.");
      setName("");
      setEmail("");
    } catch (err) {
      toast.error("Oops — couldn't subscribe. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const wrapperClass =
    variant === "card"
      ? "rounded-2xl p-8 md:p-12"
      : "p-0";
  const wrapperStyle =
    variant === "card"
      ? { backgroundColor: "var(--jaf-surface)", border: "1px solid var(--jaf-border)" }
      : {};

  return (
    <div
      className={wrapperClass}
      style={wrapperStyle}
      data-testid={`${testIdPrefix}-wrapper`}
    >
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="font-serif text-3xl sm:text-4xl mb-3">
          Get Weekly Recipes Straight to Your Inbox
        </h2>
        <p
          className="text-base mb-7"
          style={{ color: "var(--jaf-text-muted)" }}
        >
          One short, friendly email each week with our newest air fryer recipes — no spam, ever.
        </p>

        <form
          onSubmit={onSubmit}
          className="flex flex-col sm:flex-row gap-3 max-w-xl mx-auto"
          data-testid={`${testIdPrefix}-form`}
        >
          <input
            type="text"
            placeholder="Your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            data-testid={`${testIdPrefix}-name-input`}
            className="flex-1 h-12 px-4 rounded-md bg-white text-sm outline-none focus:ring-2"
            style={{
              border: "1px solid var(--jaf-border)",
              color: "var(--jaf-text)",
            }}
          />
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            data-testid={`${testIdPrefix}-email-input`}
            className="flex-1 h-12 px-4 rounded-md bg-white text-sm outline-none focus:ring-2"
            style={{
              border: "1px solid var(--jaf-border)",
              color: "var(--jaf-text)",
            }}
          />
          <button
            type="submit"
            disabled={loading}
            data-testid={`${testIdPrefix}-submit`}
            className="jaf-btn-primary h-12 px-6 rounded-md font-medium text-sm disabled:opacity-60"
          >
            {loading ? "Joining…" : "Subscribe"}
          </button>
        </form>
        <p className="text-xs mt-4" style={{ color: "var(--jaf-text-muted)" }}>
          We respect your inbox. Unsubscribe any time.
        </p>
      </div>
    </div>
  );
}
